export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST'
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS'
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE'

export const GET_TOTAL_REQUEST = 'GET_TOTAL_REQUEST'
export const GET_TOTAL_SUCCESS = 'GET_TOTAL_SUCCESS'
export const GET_TOTAL_FAILURE = 'GET_TOTAL_FAILURE'

export const ADD_NEW_USER_REQUEST = 'ADD_NEW_USER_REQUEST'
export const ADD_NEW_USER_SUCCESS = 'ADD_NEW_USER_SUCCESS'
export const ADD_NEW_USER_FAILURE = 'ADD_NEW_USER_FAILURE'

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE'

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST'
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS'
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE'
